import { isServerSideRendering } from '../../../utils/gatsby';
export function isBotpressReady() {
  return !isServerSideRendering() && window.botpress;
}
export function isBotpressInitialized() {
  return isBotpressReady() && window.botpress.initialized;
}